<template>
  <div id="app">
    <router-view v-if="isPlainLayout" />

    <el-container v-else class="site-shell">
      <!-- 顶部辅助栏:左 logo / 右 微信图标 + 搜索 -->
      <div class="site-topbar">
        <div class="container topbar-inner">
          <router-link to="/" class="topbar-logo">
            <img src="./assets/img/toplogo.jpg" alt="中云图" />
          </router-link>
          <div class="topbar-tools">
            <span class="qr-thumb">
              <svg class="wechat-icon" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
                <path fill="#07c160" d="M664.250515 250.378947c-184.32 0-333.642105 123.014737-333.642105 275.240421 0 84.021333 47.169684 158.989474 121.964632 209.704421l-30.396632 90.138947 105.903158-53.355789c34.222316 9.728 70.467368 15.414737 108.631579 15.414736 184.32 0 333.642105-123.014737 333.642105-275.240421S848.570515 250.378947 664.250515 250.378947zM563.2 460.8c-19.456 0-35.84-16.384-35.84-35.84s16.384-35.84 35.84-35.84 35.84 16.384 35.84 35.84S582.656 460.8 563.2 460.8zM765.301895 460.8c-19.456 0-35.84-16.384-35.84-35.84s16.384-35.84 35.84-35.84 35.84 16.384 35.84 35.84S784.757895 460.8 765.301895 460.8z"/>
                <path fill="#07c160" d="M379.715368 79.063579c-153.6 0-278.153684 102.4-278.153684 227.328 0 69.632 39.287579 131.826947 101.618947 173.229474l-25.330526 75.045052 88.252631-44.408421c28.564211 8.192 58.744421 12.665263 90.543158 12.665263 5.712842 0 11.317895-.215579 16.922947-.646736-3.422316-13.204211-5.281684-26.839579-5.281684-40.798316 0-101.618947 89.573053-184.32 199.948632-184.32 4.581053 0 9.108211.161684 13.581474.431158-25.007158-122.071579-138.994947-218.527579-280.414316-218.527579zM290.842947 256c-16.384 0-29.642105-13.258105-29.642105-29.642105s13.258105-29.642105 29.642105-29.642105 29.642105 13.258105 29.642105 29.642105S307.226947 256 290.842947 256zM467.429053 256c-16.384 0-29.642105-13.258105-29.642105-29.642105s13.258105-29.642105 29.642105-29.642105 29.642105 13.258105 29.642105 29.642105S483.813053 256 467.429053 256z"/>
              </svg>
              <div class="qr-pop">
                <img src="./assets/img/ercode.jpg" alt="微信二维码" />
                <span>扫码关注微信公众号</span>
              </div>
            </span>
            <div class="search-box">
              <input type="text" placeholder="站内搜索..." v-model="searchKw" @keyup.enter="onSearch" />
              <button type="button" @click="onSearch" aria-label="搜索">
                <i class="el-icon-search"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- 主导航 -->
      <el-header class="site-header" height="auto">
        <div class="container header-inner">
          <button
            class="nav-toggle"
            type="button"
            :aria-expanded="menuOpen ? 'true' : 'false'"
            @click="menuOpen = !menuOpen"
          >
            <i :class="menuOpen ? 'el-icon-close' : 'el-icon-s-operation'"></i>
          </button>

          <el-menu
            :default-active="defaultActive"
            class="el-menu-demo site-menu"
            :class="{ 'is-open': menuOpen }"
            :mode="menuMode"
            :router="router"
            @select="handleSelect"
          >
            <el-menu-item index="/">首页</el-menu-item>
            <el-menu-item index="/goin">关于我们</el-menu-item>
            <el-menu-item index="/news">新闻资讯</el-menu-item>
            <el-menu-item index="/product">产品中心</el-menu-item>
            <el-menu-item index="/case">经典案例</el-menu-item>
            <el-menu-item index="/download">联系我们</el-menu-item>
          </el-menu>
        </div>
      </el-header>

      <el-main>
        <router-view />
      </el-main>

      <!-- 页脚(全站显示) -->
      <div class="footer">
        <div class="container footer-content">
          <div class="footer-col footer-brand">
            <div class="brand-logo">
              <img src="./assets/img/logo.png" alt="中云图" />
            </div>
            <div class="brand-text">
              <strong>湖南中云图地理信息科技有限公司</strong>
              <p>无人机航测遥感 · 三维地理信息 · 行业解决方案</p>
              <p>地址：长沙高新开发区芯城科技园8栋501</p>
            </div>
          </div>
          <div class="footer-col footer-contact">
            <h4>联系方式</h4>
            <p>服务热线：<a href="tel:400-871-5117">400-871-5117</a></p>
            <p>邮　箱：zhuxingyuan010@vip.com</p>
            <p>工作时间：周一至周五 9:00-18:00</p>
          </div>
          <div class="footer-col footer-links">
            <h4>快速导航</h4>
            <p><router-link to="/goin">关于我们</router-link></p>
            <p><router-link to="/news">新闻资讯</router-link></p>
            <p><router-link to="/case">经典案例</router-link></p>
            <p><router-link to="/download">联系我们</router-link></p>
          </div>
          <div class="footer-col footer-qr">
            <img src="./assets/img/ercode.jpg" alt="微信二维码" />
            <span>关注微信公众号</span>
          </div>
        </div>
        <div class="footer-bar">
          <div class="container">
            <span>© 2020-2026 湖南中云图地理信息科技有限公司 版权所有</span>
            <span class="dot">·</span>
            <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">湘ICP备2024095317号-1</a>
            <span class="dot">·</span>
            <span>网站建设：中云图研发部</span>
          </div>
        </div>
      </div>
    </el-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      router: true,
      menuOpen: false,
      isMobile: false,
      searchKw: ""
    };
  },
  computed: {
    isPlainLayout() {
      const path = this.$route.path || "";
      return path.startsWith("/admin") || path === "/login";
    },
    defaultActive() {
      return this.$route.path || "/";
    },
    menuMode() {
      return this.isMobile ? "vertical" : "horizontal";
    }
  },
  watch: {
    "$route.path"() {
      this.menuOpen = false;
    }
  },
  mounted() {
    this.updateViewport();
    window.addEventListener("resize", this.updateViewport);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateViewport);
  },
  methods: {
    handleSelect() {
      this.menuOpen = false;
    },
    onSearch() {
      const kw = (this.searchKw || "").trim();
      if (!kw) return;
      this.$message && this.$message.info(`搜索：${kw}（功能待接入）`);
    },
    updateViewport() {
      this.isMobile = window.innerWidth <= 960;
      if (!this.isMobile) this.menuOpen = false;
    }
  }
};
</script>

<style lang="scss">
@import "./assets/styles/variables.scss";

#app {
  min-height: 100%;
}

.site-shell {
  background: $color-bg-2;
}

.el-container.site-shell {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

// —— 顶部辅助栏 —— //
.site-topbar {
  width: 100%;
  background: #fff;
  border-bottom: 1px solid $color-border;
}

.topbar-inner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 72px;
  padding: 8px 0;
  gap: 24px;
}

.topbar-logo {
  display: flex;
  align-items: center;
  height: 56px;
  flex-shrink: 0;

  img {
    height: 56px;
    width: auto;
    display: block;
  }
}

.topbar-tools {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-shrink: 0;
}

.qr-thumb {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  cursor: pointer;
  border: 1px solid $color-border;
  background: $color-bg-2;
  transition: border-color 0.2s ease, background 0.2s ease;

  &:hover {
    border-color: #07c160;
    background: #fff;

    .qr-pop {
      opacity: 1;
      transform: translate(-50%, 0);
      pointer-events: auto;
    }
  }

  .wechat-icon {
    width: 24px;
    height: 24px;
    display: block;
  }

  .qr-pop {
    position: absolute;
    top: calc(100% + 8px);
    left: 50%;
    width: 170px;
    padding: 10px;
    background: #fff;
    border: 1px solid $color-border;
    text-align: center;
    box-shadow: 0 8px 24px rgba(15, 47, 74, 0.18);
    opacity: 0;
    transform: translate(-50%, 8px);
    pointer-events: none;
    transition: opacity 0.2s ease, transform 0.2s ease;
    z-index: 200;

    &::before {
      content: "";
      position: absolute;
      top: -6px;
      left: 50%;
      transform: translateX(-50%) rotate(45deg);
      width: 10px;
      height: 10px;
      background: #fff;
      border-left: 1px solid $color-border;
      border-top: 1px solid $color-border;
    }

    img {
      width: 148px;
      height: 148px;
      display: block;
      margin: 0 auto;
    }

    span {
      display: block;
      margin-top: 8px;
      color: $color-text-2;
      font-size: 12px;
    }
  }
}

.search-box {
  display: flex;
  align-items: stretch;
  height: 34px;
  border: 1px solid $color-primary;
  background: #fff;

  input {
    flex: 1;
    min-width: 180px;
    height: 100%;
    border: none;
    outline: none;
    padding: 0 12px;
    font-size: 13px;
    color: $color-text;
    background: transparent;
  }

  button {
    width: 44px;
    border: none;
    background: $color-primary;
    color: #fff;
    font-size: 16px;
    cursor: pointer;
    transition: background 0.2s ease;

    &:hover { background: $color-primary-dark; }
  }
}

// —— 主导航(深蓝底,白字) —— //
.site-header {
  padding: 0 !important;
  background: #1565c0;
  z-index: 100;
}

.header-inner {
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  position: relative;
  min-height: $nav-height;
  padding: 0;
}

.nav-toggle {
  display: none;
  width: 40px;
  height: 40px;
  border: 1px solid rgba(255, 255, 255, 0.4);
  background: transparent;
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  align-self: center;
  margin-right: 8px;
}

.site-menu.el-menu,
.el-menu--horizontal {
  border-right: none !important;
  border-bottom: none !important;
}

.site-menu.el-menu {
  background: transparent;
  flex: 1;
  justify-content: center;
}

.el-menu--horizontal > .el-menu-item {
  height: $nav-height;
  line-height: $nav-height;
  font-size: 16px;
  color: #fff !important;
  padding: 0 28px;
  letter-spacing: 2px;
  border-bottom: none !important;
}

.el-menu--horizontal > .el-menu-item:hover {
  background: #1976d2 !important;
  color: #fff !important;
  border-bottom: none !important;
}

.el-menu--horizontal > .el-menu-item.is-active {
  background: #0d47a1 !important;
  color: #fff !important;
  border-bottom: none !important;
}

.el-main {
  padding: 0 !important;
  flex: 1;
  overflow: visible; // 让内页的 sticky 内容导航相对视口生效
}

// —— 页脚 —— //
.footer {
  width: 100%;
  background: $color-bg-3;
  color: $color-text-2;
  font-size: 13px;
}

.footer-content {
  display: grid;
  grid-template-columns: 1.4fr 1fr 1fr 0.8fr;
  gap: 36px;
  padding: 36px 0 30px;
}

.footer-col {
  h4 {
    margin: 0 0 12px;
    font-size: 15px;
    font-weight: 600;
    color: $color-text;
    padding-left: 8px;
    border-left: 3px solid $color-primary;
    line-height: 1.2;
  }

  p {
    margin: 5px 0;
    line-height: 1.85;
    color: $color-text-2;
    font-size: 13px;
  }

  a {
    color: $color-text-2;
  }

  a:hover {
    color: $color-accent;
  }
}

.footer-brand {
  display: flex;
  gap: 14px;

  .brand-logo {
    width: 60px;
    height: 60px;
    flex-shrink: 0;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  .brand-text strong {
    display: block;
    font-size: 15px;
    color: $color-text;
    margin-bottom: 6px;
    font-weight: 600;
  }

  .brand-text p {
    margin: 4px 0;
    font-size: 12px;
    line-height: 1.7;
  }
}

.footer-qr {
  text-align: center;

  img {
    width: 96px;
    height: 96px;
    background: #fff;
    padding: 4px;
    border: 1px solid $color-border-dark;
    display: block;
    margin: 0 auto 8px;
  }

  span {
    display: block;
    color: $color-text-2;
    font-size: 12px;
  }
}

.footer-bar {
  background: $color-footer-bar;
  color: rgba(255, 255, 255, 0.78);
  font-size: 12px;
  padding: 12px 0;
  text-align: center;

  .container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    gap: 4px 10px;
  }

  .dot {
    color: rgba(255, 255, 255, 0.35);
  }

  a {
    color: rgba(255, 255, 255, 0.78);

    &:hover {
      color: $color-gold;
    }
  }
}

// —— 响应式 —— //
@media (max-width: 960px) {
  .topbar-inner { min-height: 60px; }
  .topbar-logo img { height: 44px; }
  .search-box input { min-width: 120px; }

  .nav-toggle {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .site-menu.el-menu {
    display: none;
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    z-index: 120;
    background: #1565c0;
    padding: 0;
  }

  .site-menu.el-menu.is-open { display: block; }

  .site-menu .el-menu-item {
    height: 46px;
    line-height: 46px;
    margin: 0 !important;
    padding: 0 16px !important;
    float: none !important;       // 桌面 .el-menu--horizontal 有 float:left,这里必须清掉,否则菜单项会浮在左边
    display: block !important;
    width: 100% !important;
    box-sizing: border-box !important;
    color: #fff !important;
    border-bottom: none !important;
  }

  .site-menu .el-menu-item:hover {
    background: #1976d2 !important;
    color: #fff !important;
    border-bottom: none !important;
  }

  .site-menu .el-menu-item.is-active {
    background: #0d47a1 !important;
    color: #fff !important;
    border-bottom: none !important;
  }

  // —— 平板:2 列网格,精简品牌区 ——
  .footer-content {
    grid-template-columns: 1fr 1fr;
    gap: 24px;
    padding: 24px 0;
  }

  .footer-brand .brand-text p { display: none; }
  .footer-brand .brand-text strong { margin-bottom: 0; }

  .footer-qr {
    grid-column: span 2;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 12px;
    text-align: left;

    img { margin: 0; width: 64px; height: 64px; }
    span { margin-top: 0; }
  }
}

@media (max-width: 640px) {
  .topbar-tools { gap: 10px; }
  // 手机端隐藏搜索框（功能待接入，单纯占位）
  .search-box { display: none; }

  // 微信二维码弹窗贴右对齐 qr-thumb 右边缘
  // 桌面端用 left:50% + translate(-50%) 居中,但 mobile 下 .qr-thumb 已贴近屏幕右边,
  // 居中后 170px 的弹窗右边会超出屏幕一半
  .qr-pop,
  .qr-thumb:hover .qr-pop {
    left: auto;
    right: 0;
    transform: none;
  }

  // —— 手机端:单列极简,只保留品牌 + 联系方式 + 备案条 ——
  .footer-content {
    grid-template-columns: 1fr;
    gap: 18px;
    padding: 20px 0 16px;
  }

  .footer-brand { gap: 12px; align-items: center; }
  .footer-brand .brand-logo { width: 40px; height: 40px; }
  .footer-brand .brand-text strong { font-size: 13px; line-height: 1.4; }

  // 隐藏非关键信息,极简化
  .footer-links,
  .footer-qr { display: none; }

  .footer-contact {
    h4 { font-size: 13px; margin-bottom: 10px; }
    p { margin: 4px 0; font-size: 12px; line-height: 1.7; }
  }

  .footer-bar .container {
    flex-direction: column;
    gap: 4px;
    font-size: 11px;
    .dot { display: none; }
  }
}
</style>
